import { IInputProgress, IInputStatus } from '../../../interface/progress.interface'

interface Props {
  status: IInputStatus;
  input: IInputProgress;
  increaseProgress: Function;
  decreaseProgress: Function;
}
const changeInputProgress = ({
  status,
  input,
  increaseProgress,
  decreaseProgress
}: Props) => {
  if (status === IInputStatus.none) {
    if (input.status === IInputStatus.success) {
      decreaseProgress(input.percent)
    }

  } else if (status === IInputStatus.change) {
    if (input.status === IInputStatus.success) {
      decreaseProgress(input.percent)
    }
  } else if (status === IInputStatus.success) {
    if (input.status !== IInputStatus.success) {
      increaseProgress(input.percent)
    }
   
  }
}

export default changeInputProgress